import axios from '@axios'

const readUserData = () => {
  try {
    return JSON.parse(localStorage.getItem('userData') || '{}')
  } catch (error) {
    return {}
  }
}

const state = {
  currentDocuments: [],
  currentLoaded: false,
  adminDocuments: [],
  requirementsChecked: false,
}

const getters = {
  currentDocuments: state => state.currentDocuments,
  currentDocument: state => kind => state.currentDocuments.find(document => document.kind === kind) || null,
  adminDocuments: state => state.adminDocuments,
}

const mutations = {
  SET_CURRENT_DOCUMENTS(state, documents) {
    state.currentDocuments = documents
    state.currentLoaded = true
  },
  SET_ADMIN_DOCUMENTS(state, documents) {
    state.adminDocuments = documents
  },
  SET_REQUIREMENTS_CHECKED(state, value) {
    state.requirementsChecked = value
  },
}

const storeRequirements = (commit, payload) => {
  const userData = readUserData()
  const updated = {
    ...userData,
    account_requirements: payload.account_requirements || [],
  }
  if (payload.phone && updated.customer) {
    updated.customer = { ...updated.customer, phone: payload.phone }
  }
  localStorage.setItem('userData', JSON.stringify(updated))
  commit('auth/setCurrentUser', updated, { root: true })
  return updated
}

const actions = {
  async fetchCurrentLegal({ commit }) {
    const { data } = await axios.get('/v1/legal_documents/current', { skipErrorToast: true })
    commit('SET_CURRENT_DOCUMENTS', data.data || [])
    return data.data || []
  },

  async refreshAccountRequirements({ commit }) {
    const { data } = await axios.get('/v1/account/requirements', { skipErrorToast: true })
    commit('SET_REQUIREMENTS_CHECKED', true)
    return storeRequirements(commit, data)
  },

  async completeAccount({ commit }, { phone, acceptLegal }) {
    const { data } = await axios.post('/v1/account/requirements', { phone, accept_legal: acceptLegal }, { skipErrorToast: true })
    commit('SET_REQUIREMENTS_CHECKED', true)
    return storeRequirements(commit, data)
  },

  async fetchAdminLegalDocuments({ commit }) {
    const { data } = await axios.get('/v1/legal_documents')
    commit('SET_ADMIN_DOCUMENTS', data.data || [])
    return data.data || []
  },

  async saveLegalDocument({ dispatch }, {
    id,
    kind,
    title,
    body,
  }) {
    const payload = { legal_document: { title, body } }
    if (id) {
      await axios.put(`/v1/legal_documents/${id}`, payload, { skipErrorToast: true })
    } else {
      payload.legal_document.kind = kind
      await axios.post('/v1/legal_documents', payload, { skipErrorToast: true })
    }
    return dispatch('fetchAdminLegalDocuments')
  },

  async publishLegalDocument({ dispatch }, id) {
    await axios.put(`/v1/legal_documents/${id}/publish`, {}, { skipErrorToast: true })
    return dispatch('fetchAdminLegalDocuments')
  },

  async deleteLegalDocument({ dispatch }, id) {
    await axios.delete(`/v1/legal_documents/${id}`, { skipErrorToast: true })
    return dispatch('fetchAdminLegalDocuments')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
